import i18next from 'i18next';
import { JOB_PAGE_STATES } from '@model/Job/_constants/Job.constants';

export const header = () => ({
  welcome: i18next.t('header.welcome'),
  share: i18next.t('header.share'),
  hide_compensation: i18next.t('header.hide_compensation'),
  show_compensation: i18next.t('header.show_compensation'),
});

export const profile = () => ({
  contract: {
    title: i18next.t('profile.contract.title'),
    buttonProps: {
      label: i18next.t('profile.contract.download'),
    },
    image: 'https://via.placeholder.com/216x216',
  },
  referenceHeader: {
    title: i18next.t('profile.references.title'),
  },
  blankReferentCard: {
    title: i18next.t('profile.references.blank.title'),
    text: i18next.t('profile.references.blank.text'),
  },
  mirror: {
    body: i18next.t('profile.mirror.body'),
    linkLabel: i18next.t('profile.mirror.link'),
  },
});

export const hero = (status, payload = null) => {
  const interviewingMarketingStatus = payload?.hasCandidates
    ? JOB_PAGE_STATES.DOING
    : JOB_PAGE_STATES.TO_DO;

  return {
    steps: ({ isMiroUrlAvailable, isJobReverseMarketing }) => [
      {
        name: 'profiling',
        title: isMiroUrlAvailable
          ? i18next.t('hero.steps.profiling.title')
          : i18next.t('hero.steps.profiling.title_no_miro'),
        description: i18next.t('hero.steps.profiling.description'),
        icon: 'icn-user-pin',
      },
      ...(isJobReverseMarketing
        ? []
        : [
            {
              name: 'searching',
              title: i18next.t('hero.steps.searching.title'),
              description: i18next.t('hero.steps.searching.description'),
              icon: 'icn-search',
            },
          ]),
      {
        name: 'showcase',
        title: i18next.t('hero.steps.showcase.title'),
        description: i18next.t('hero.steps.showcase.description'),
        icon: 'icn-grid-outline',
      },
      {
        name: 'interviewing',
        title: isJobReverseMarketing
          ? i18next.t('hero.steps.interviewing.title_marketing')
          : i18next.t('hero.steps.interviewing.title'),
        description: i18next.t('hero.steps.interviewing.description'),
        icon: isJobReverseMarketing ? 'icn-user-star' : 'icn-chat',
      },
      {
        name: 'closing',
        title: i18next.t('hero.steps.closing.title'),
        description: i18next.t('hero.steps.closing.description'),
        icon: 'icn-flag-outline',
      },
    ],
    helperText: {
      profiling: payload?.isJobReverseMarketing
        ? i18next.t(`hero.helper.marketing.profiling.${status}`, payload)
        : i18next.t(`hero.helper.profiling.${status}`, payload),
      searching: i18next.t(`hero.helper.searching.${status}`, payload),
      showcase: i18next.t('showcase.bubbleText'),
      interviewing: payload?.isJobReverseMarketing
        ? i18next.t(
            `hero.helper.marketing.interviewing.${interviewingMarketingStatus}`,
            payload,
          )
        : i18next.t(`hero.helper.interviewing.${status}`, payload),
      closing: i18next.t(`hero.helper.closing.${status}`, payload),
    },
  };
};

export const interviewing = () => ({
  header: status => ({
    title: i18next.t('interviewing.header.title'),
    body:
      status === 'to-do'
        ? i18next.t('interviewing.header.subtitle')
        : i18next.t('interviewing.header.subtitle_bis'),
  }),
  referenceHeader: {
    title: i18next.t('interviewing.referenceHeader.title'),
  },
  alert: {
    text: i18next.t('interviewing.alert.text'),
  },
  tabs: {
    all: i18next.t('interviewing.tabs.all'),
    active: i18next.t('interviewing.tabs.active'),
    discarded: i18next.t('interviewing.tabs.discarded'),
  },
  tabsTitle: i18next.t('interviewing.tabs.see'),
});

export const closing = () => ({
  header: {
    title: i18next.t('closing.header.title'),
    body: i18next.t('closing.header.subtitle'),
  },
  bingoHeader: {
    label: i18next.t('closing.bingoHeader.label'),
    sublabel: i18next.t('closing.bingoHeader.sublabel'),
  },
  links: {
    resignation_letter: i18next.t('closing.links.resignation_letter'),
    commitment_letter: i18next.t('closing.links.commitment_letter'),
    prospect: i18next.t('closing.links.prospect'),
  },
  tag: infos => ({
    text: i18next.t('closing.tag.text', { ...infos }),
  }),
});

export const error = () => ({
  title: i18next.t('general.error.title'),
  subtitle: i18next.t('general.error.subtitle'),
});
